import { useEffect, useMemo, useState } from "react";
import { countries as allCountries, countries } from "../../global/countriesAndSources"
import {ProfileHeader } from "./profileHeader"
import { useParams } from 'react-router-dom';
import translation, { getIgo, getLangFromCountry, getTranslation } from "../../HTTP/translation";
import "./GoogleCSE.css"
import "./articles.css"
import GoogleCSE from "./GoogleCSE";
import { CountryBar } from "./countryBar";
import Map from "../Map/Map";
import { fetchLinksThematics, getSearchInCseThematic } from "../../HTTP/thematics";


export default function WhatThisCountryTalkAbout () {
    const [displayMap, setDisplayMap] = useState(false)
    const [selectedIgo, setSelectedIgo] = useState({name:"Selectionner une OIG", country_list: ""})
    const [igo, setIgo] = useState([])
    const [igoReady, setIgoReady] = useState(false)
    const [links, setLinks] = useState([])
    // État pour le site sélectionné dans la liste
    const [selectedSite, setSelectedSite] = useState(null);
    // État pour contrôler l'affichage du dropdown de sites
    const [showSiteDropdown, setShowSiteDropdown] = useState(false);
    const url = useMemo(() => new URL(window.location.href), []);
    const [searchQuery, setSearchQuery] = useState(sessionStorage.getItem("search_query") || "");
    const [searchInCse, setSearchInCse] = useState(false);

    let { countrycode } = useParams(); // Assurez-vous que le nom du paramètre correspond à celui défini dans votre route 
    
    let country = countrycode ? allCountries.find((c) => c.code === countrycode) : null
    country = country
            || JSON.parse(sessionStorage.getItem("search_country"))
            || allCountries.find((c) => c.code === JSON.parse(localStorage.getItem('user'))?.country)
            || { name: "France", code: "fr", cse: "004899679196972058950:gvpguoasgrm" }
    if (JSON.parse(sessionStorage.getItem('search_country')) === null) {
        sessionStorage.setItem('search_country',JSON.stringify(country))
    }

    const [selectedCountry] = useState(country)
    

    const handleSiteSelect = (site) => {
        setSelectedSite(site);
        if (site === null) {
            url.searchParams.delete('link-id')
            window.history.pushState({}, '', url);
            sessionStorage.removeItem('selected_site')
        } else {
            url.searchParams.set('link-id', site.id)
            window.history.pushState({}, '', url);
            sessionStorage.setItem('selected_site', JSON.stringify(site))
        }
        setShowSiteDropdown(false);
    };


	// 1. Modifiez votre fonction handleSearch pour stocker aussi le site sélectionné
	const handleSearch = async () => {
		// Si nécessaire, traduisez la requête avant de la soumettre
		let finalQuery = searchQuery;
		
		if (document.getElementById("translate_query") && document.getElementById("translate_query").checked) {
		try {
			const langDest = await getLangFromCountry(selectedCountry.code);
			const translated = await getTranslation(
			sessionStorage.getItem("currentlanguage"),
			langDest,
			searchQuery
			);
			finalQuery = translated;
			setSearchQuery(translated); // Mettez à jour le champ de recherche avec la traduction
		} catch (error) {
			console.error("Erreur lors de la traduction:", error);
		}
		}
		
		// Stockez la requête simple dans sessionStorage
		sessionStorage.setItem("search_query", finalQuery);
		
		// Stockez aussi le site sélectionné s'il existe
		if (selectedSite) {
		sessionStorage.setItem("selected_site", JSON.stringify(selectedSite));
		} else {
		sessionStorage.removeItem("selected_site"); // Supprimer si pas de site sélectionné
		}
		
		// Ajoutez le préfixe site: si un site est sélectionné
		if (selectedSite) {
		finalQuery = `site:${selectedSite.link} ${finalQuery}`;
		} else if (!searchInCse) {
            finalQuery = links.map(link => "site:"+link.link).join(" OR ") + " " + finalQuery
        }

        // Ajouter le prefixe site: si nous avons une oig de séléctionné et nous sommes dans le pays monde
        if (selectedIgo.name !== "Séléctionner une OIG" && selectedCountry.code === 'wd' && !sessionStorage.getItem('thematic')) {
            finalQuery = `site:${selectedIgo.link} ${finalQuery}`;
        }
		
		// Soumettez la requête à la barre de recherche Google cachée
		const googleInput = document.querySelector("input#gsc-i-id1");
		const googleButton = document.querySelector("button.gsc-search-button-v2");
		
		if (googleInput && googleButton) {
		googleInput.value = finalQuery;
		googleButton.click();
		}
	};

    useEffect(() => {
        const funIgo = async () => {
            const res = await getIgo()
            setIgo(res)
            const url = new URL(window.location.href)
            if (url.searchParams.get('igo') !== null) {
                const igoSelected = res.find((i) => i.name === url.searchParams.get('igo'))
                if (igoSelected) {
                    setSelectedIgo(igoSelected)
                } else {
                    url.searchParams.delete('igo')
                    setSelectedIgo(res[0])
                }
            } else if (sessionStorage.getItem('search_igo') !== null) {
                const igoFound = res.find((i) => i.name === sessionStorage.getItem('search_igo'))
                if (igoFound) {
                    setSelectedIgo(igoFound)
                } else {
                    sessionStorage.removeItem('search_igo')
                    setSelectedIgo(res[0])
                }
            } else {
                setSelectedIgo(res[0])
            }
        }
        const fetchLinks = async () => {
			try {
				const response = await fetchLinksThematics(sessionStorage.getItem('thematic'), selectedCountry.code, sessionStorage.getItem('search_igo'))
				if (response) {
					setLinks(response)
                }
				const selectedLinkId = url.searchParams.get('link-id')
				console.log("selectedLinkId", selectedLinkId)
				console.log("response", response)
				if (selectedLinkId) {
					const selectedLink = response.find(link => link.id === parseInt(selectedLinkId))
					console.log("selectedLink", selectedLink)
					if (selectedLink) {
						setSelectedSite(selectedLink)
					} else {
						setSelectedSite({})
						url.searchParams.delete('link-id')
						window.history.pushState({}, '', url);
						sessionStorage.removeItem('selected_site')
					}
				}
			} catch (error) {
				console.error("Error fetching thematic links:", error)
			}
		}
        const fetchSearchInCse = async () => {
            try {
                const response = await getSearchInCseThematic(sessionStorage.getItem('thematic'), selectedCountry.code)
                if (response) {
                    if (response.search_in_cse === 1) {
                        setSearchInCse(true)
                    }
                }
                setSearchInCse(false)
            } catch (error) {
                console.error("Error fetching search in CSE:", error)
            }
        }
        fetchSearchInCse()
		fetchLinks()
        funIgo()
        setIgoReady(true)
    }, [selectedCountry, url])

    if (sessionStorage.getItem('search_country_country') !== null) {
        sessionStorage.removeItem('search_country_country')
    }
    if (sessionStorage.getItem('search_themes_country') !== null) {
        sessionStorage.removeItem('search_themes_country')
    }
    sessionStorage.setItem('listmiddle', "De quoi parle-t-on ?")

    

    const selectNewCountry = async (country) => {
        const langDest = await translation.getLangFromCountry(country.code)
        let trad
        if (langDest !== document.documentElement.lang) trad = await translation.getTranslation(document.documentElement.lang, langDest, country.name)
        window.location.href = `/${country.code}/what-this-country-talk-about`
        sessionStorage.setItem("search_country", JSON.stringify(country))
    }

    const handleDisplayMap = () => {
		if(displayMap) {
			setDisplayMap(false)
		} else {
			setDisplayMap(true)
		}
	}
    
    return (
        <>
        <ProfileHeader 
                selectedCountry={selectedCountry} 
                setSelectedCountry = {(country) => selectNewCountry(country)}
                igo = {igo}
                igoReady = {igoReady}
                selectedIgo = {selectedIgo}
                setSelectedIgo = {(igo) => setSelectedIgo(igo)}
                links = {links}
                setLinks = {(links) => setLinks(links)}
                selectedSite = {selectedSite}
                setSelectedSite = {(site) => handleSiteSelect(site)}
                searchInCse = {searchInCse}
                showSiteDropdown = {showSiteDropdown}
                setShowSiteDropdown = {(show) => setShowSiteDropdown(show)}
                handleSiteSelect = {(site) => handleSiteSelect(site)}
                searchQuery = {searchQuery}
                setSearchQuery = {(query) => setSearchQuery(query)}
                handleSearch = {handleSearch}
                displayMap = {() => handleDisplayMap()}
            />
        <div className="flex">
            <div className="flex-1">
                {
                    selectedIgo.name !== "Séléctionner une OIG" && (
                        <>
                            <div className="flex flex-col-reverse xl:flex-row xl:justify-between items-center ml-2 mr-2">
                                <h2 className="text-sm xl:text-xl"><button onClick={
                                    () => {
                                        sessionStorage.removeItem('search_themes_country')
                                        sessionStorage.removeItem('search_country_country')
                                        sessionStorage.setItem("search_country", JSON.stringify(countries.find(c => c.code === 'wd')))
                                        sessionStorage.setItem("search_query", "")
                                        sessionStorage.removeItem('thematic')
                                        window.location.href = "/"
                                    }
                                }>{selectedIgo.label}</button></h2>
                                {
                                    selectedIgo.image && (
                                        <a href={selectedIgo.link} target="_blank" rel="noopener noreferrer"><img className="w-auto h-16 xl:h-20" src={selectedIgo.image} alt={"Logo " + selectedIgo.name} /></a>
                                    )
                                }
                            </div>
                        </>
                    )
                }
                <Map 
                    selectedCountry={selectedCountry} 
                    setSelectedCountry = {(country) => selectNewCountry(country)}
                    displayMap = {displayMap}
                    setDisplayMap = {(hide) => setDisplayMap(hide)}
                />
                <div className="max-h-[75vh] overflow-y-auto">
                    <GoogleCSE 
                    selectedCountry = {country}
                    selectedSite = {selectedSite}
                />
                </div>
            </div>
            <div id="pays_large" className="w-60 bg-neutral-50">
            <CountryBar
                selectedCountry = {country}
                setSelectedCountry = {(country) => selectNewCountry(country)}
                selectedIgo = {selectedIgo}
                setSelectedIgo = {(igo) => setSelectedIgo(igo)}
                displayMap = {() => handleDisplayMap()}
                isMobile = {false}
                igo = {igo}
                igoReady = {igoReady}
            />
            </div>
        </div>
        </>
    )
}